import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-connect-pos',
  templateUrl: './connect-pos.component.html',
  styleUrls: ['./connect-pos.component.scss']
})
export class ConnectPosComponent implements OnInit {

  @Input() partner;
  @Input() selectPOS;
  public loading = true;
  public message = null;  

  constructor(
    public modal: NgbActiveModal
  ) { }

  ngOnInit() {
  }

}
